import React from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import searchIcon from '../assets/SidebarIcons/icon-search.svg';
import CustomAlert from './CustomAlert';

// Admin list page: title, search on the left, actions on the right, alert, paginated table.
// Filtering stays in the page: pass `search`/`onSearch` and the already-filtered `data`.
// `children` (usually modals) render after the table.
const ListPage = ({
  title,
  search,
  onSearch,
  actions,
  alert,
  setAlert,
  columns,
  data,
  loading,
  tableKey,
  children,
}) => (
  <div className="w-100">
    <div className="page-heading admin-heading px-0">
      <div className="container-left" style={{ marginBottom: '32px' }}>
        <div className="page-title">{title}</div>
      </div>
      <div className="w-100 d-flex justify-content-between align-items-center">
        <div className="w-50">
          <InputGroup className="datatable-search search-input">
            <InputGroup.Append>
              <InputGroup.Text>
                <img alt="..." src={searchIcon} />
              </InputGroup.Text>
            </InputGroup.Append>
            <Form.Control
              placeholder="Search..."
              name="search"
              value={search}
              onChange={onSearch}
              className="search-form"
            />
          </InputGroup>
        </div>
        {actions && <div className="d-flex gap-2">{actions}</div>}
      </div>
    </div>
    {alert && (
      <CustomAlert
        message={alert.message}
        show={alert.show}
        variant={alert.variant}
        closeAlert={() => setAlert({ show: false, variant: 'danger', message: '' })}
      />
    )}
    <DataTable
      key={tableKey}
      columns={columns}
      data={data}
      progressPending={loading}
      paginationComponentOptions={{ rowsPerPageText: 'Items per page:' }}
      pagination
    />
    {children}
  </div>
);

export default ListPage;
